( function( $ ) {
	"use strict";

	var $carouselProgrammes;
	var $carouselAwards;
	var $carouselBlog;
	var $carouselProgrammesContent;
	var $carouselTestimonials;

	function initializeProgrammesCarousel( $sel ) {
		var carousel;

		enquire.register( '(max-width: 1023px)', {
			match: function() {
				carousel = $sel.owlCarousel( {
					nav: false,
					dots: true,
					margin: 20,
					responsive: {
						0: {
							items: 1,
							stagePadding: 30
						},
						650: {
							items: 2,
							stagePadding: 30
						},
						768: {
							items: 2,
							stagePadding: 50
						},
						1024: {
							items: 3
						},
						1440: {
							margin: 30
						}
					}
				} );
			},
			unmatch: function() {
				carousel.trigger( 'destroy.owl.carousel' );
			}
		} );
	}

	function initializeProgrammesContentCarousel( $sel ) {
		var carousel;

		enquire.register( '(max-width: 1439px)', {
			match: function() {
				carousel = $sel.owlCarousel( {
					nav: false,
					dots: true,
					margin: 20,
					responsive: {
						0: {
							items: 1,
							stagePadding: 30
						},
						650: {
							items: 2,
							stagePadding: 30
						},
						768: {
							items: 2,
							stagePadding: 50
						},
						1024: {
							items: 2,
							stagePadding: 50
						},
						1440: {
							margin: 30
						}
					}
				} );
			},
			unmatch: function() {
				carousel.trigger( 'destroy.owl.carousel' );
			}
		} );
	}

	function initializeAwardsCarousel( $sel ) {
		var carousel;

		enquire.register( '(max-width: 1439px)', {
			match: function() {
				carousel = $sel.owlCarousel( {
					nav: false,
					dots: true,
					margin: 20,
					responsive: {
						0: {
							items: 1
						},
						1024: {
							items: 2,
							autoWidth: true,
							margin: 50
						},
						1440: {
							margin: 30
						}
					}
				} );
			},
			unmatch: function() {
				carousel.trigger( 'destroy.owl.carousel' );
			}
		} );
	}

	function initializeBlogCarousel( $sel ) {
		var carousel;

		enquire.register( '(max-width: 1023px)', {
			match: function() {
				carousel = $sel.owlCarousel( {
					nav: false,
					dots: true,
					margin: 20,
					responsive: {
						0: {
							items: 1,
							stagePadding: 30
						},
						650: {
							items: 2,
							stagePadding: 30
						},
						768: {
							items: 2,
							stagePadding: 50
						},
						1024: {
							items: 3
						},
						1440: {
							margin: 30
						}
					}
				} );
			},
			unmatch: function() {
				carousel.trigger( 'destroy.owl.carousel' );
			}
		} );
	}

	function initializeTestimonialsCarousel( $sel ) {
		$sel.owlCarousel( {
			nav: false,
			dots: true,
			items: 1,
			margin: 30,
			autoHeight: true
		} );
	}

    $( function() {
    	$carouselProgrammes = $( '.js-carousel-programmes' );
    	$carouselProgrammesContent = $( '.js-carousel-programmes-content' );
    	$carouselAwards = $( '.js-carousel-awards' );
	    $carouselBlog = $( '.js-carousel-blog' );
	    $carouselTestimonials = $( '.js-carousel-testimonials' );

    	if ( $carouselProgrammes.length ) {
		    initializeProgrammesCarousel( $carouselProgrammes );
	    }

	    if ( $carouselProgrammesContent.length ) {
		    initializeProgrammesContentCarousel( $carouselProgrammesContent );
	    }

	    if ( $carouselAwards.length ) {
		    initializeAwardsCarousel( $carouselAwards );
	    }

	    if ( $carouselBlog.length ) {
		    initializeBlogCarousel( $carouselBlog );
	    }

	    if ( $carouselTestimonials.length ) {
		    initializeTestimonialsCarousel( $carouselTestimonials );
	    }
    } );
} )( jQuery );
